import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { Title, Description } from './PageTitle.style'
import Container from '../../static-app/Container'

const PageTitle = ({ title, description }) => (
  <Container className="pageTitle">
    <Title
      className="wow fadeIn"
      data-wow-delay="0.3s"
      hasDescription={!!description}
    >
      {title}
    </Title>
    { description && (
      <Description
        className="wow fadeIn"
        data-wow-delay="0.5s"
        dangerouslySetInnerHTML={{
          __html: description.childMarkdownRemark.html,
        }}
      />
    )}
  </Container>
)

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string.isRequired,
    }),
  }),
}

PageTitle.defaultProps = {
  description: null,
}

export default PageTitle

export const PageTitleFragment = graphql`
  fragment PageTitleFragment on ContentfulPageTitle {
    id
    title
    description {
      childMarkdownRemark {
        html
      }
    }
  }
`
